import { Ellipsis, Tabs } from '@seiue/ui'
import { FormInstance } from 'antd'
import { Plugin } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'
import styled from 'styled-components'

import { getSystemPluginIcon } from '../../utils/util'

import { SystemPluginConfig } from './SystemPluginConfig'
import { UserPluginContent } from './UserPluginContent'

/**
 * 编辑系统应用弹窗 - 弹窗内容 - 基础设置
 *
 * @param param - 参数
 * @param param.form - 表单
 * @param param.plugin - 系统应用
 * @returns 组件
 */
export const SystemPluginContent: React.FC<{
  form: FormInstance<AnyType>
  plugin: Plugin
}> = ({ form, plugin }) => {
  const tabItems = [
    {
      label: '基础配置',
      key: 'base',
      children: (
        <UserPluginContent
          form={form}
          nostyle={true}
        />
      ),
    },
    {
      label: '应用配置',
      key: 'other',
      children: (
        <SystemPluginConfig
          form={form}
          plugin={plugin}
        />
      ),
    },
  ]

  return (
    <Box>
      <ItemBox>
        <ImgBox src={getSystemPluginIcon(plugin)} />
        <DescBox>
          <TitleBox>
            <>{plugin.label}</>
          </TitleBox>
          <Ellipsis
            text={plugin.description}
            style={{ color: '#455766', width: '50vw' }}
          />
        </DescBox>
      </ItemBox>
      <StyledTabs items={tabItems} />
    </Box>
  )
}

const Box = styled.div`
  width: 960px;
  background-color: #fff;
  padding: 24px;
  border-radius: 12px;
`

const ItemBox = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: row;
  padding: 0px;
  gap: 12px;
  align-self: stretch;
  margin-bottom: 26px;
`

const ImgBox = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 12px;
  border: 1px solid ${(props) => props.theme.border.greyNormal};
`

const DescBox = styled.div`
  height: 56px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;
`

const TitleBox = styled.div`
  height: 32px;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: ${(props) => props.theme.text._1};
  display: flex;
  justify-content: space-between;
`

const StyledTabs = styled(Tabs)`
  & .ant-tabs-tab {
    font-weight: 400 !important;
    color: #455766;
  }
  & .ant-tabs-tab-active > .ant-tabs-tab-btn {
    color: ${(props) => props.theme.brand._1};
  }
`
